module.exports = __webpack_public_path__ + "img/_3.f7c90ae0.png";